import { Input } from "@vds/inputs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AutoHeightContainer,
  FrameForAllFOVs,
  FrameForIMGandInput,
  FrameForImages,
  FrameForLabelAndInput,
  NameStreamGrayContainer,
  StreamDescriptiveText,
} from "../../global/components/OnboardingFormStyles/Styles";
import { isDuplicateCamName } from "../../global/utility/Utils";
import { getFovNames, setCameraName } from "../../store/actions";
import SnapshotComponent from "./SnapshotComponent";
import { CAMERA_ONBOARDING_TEST_IDS } from "./cameraOnboardingConstants";

const NameStream = ({ editFlow }) => {
  const dispatch = useDispatch();
  const fieldOfViews =
    useSelector((state) => state.cameraonboardingReducer.fovNames) || [];

  const { cameraName, camDetails, selectedCameraQR, companionSelected } =
    useSelector((state) => state.cameraonboardingReducer);
  const { fovList, cameraList } = useSelector((state) => state.deviceReducer);
  const [isDuplCamName, setIsDuplCamName] = useState(false);
  const fovId = camDetails?.camDetails?.id || camDetails?.camName;

  useEffect(() => {
    if (!fieldOfViews) {
      const fovItems =
        fovList?.filter((item) => item.parentdeviceid === fovId) || [];
      if (fovItems?.length) {
        const defaultFOVNames = fovItems?.map((item) => item?.name);
        dispatch(getFovNames(defaultFOVNames));
      }
    }
    const selCamId = !camDetails?.isPairing
      ? camDetails?.camDetails?.id
      : selectedCameraQR;
    isDuplicateCamName(cameraList, selCamId, cameraName) &&
      setIsDuplCamName(true);
  }, [dispatch]);

  const handleFOVNameChange = (e, index, fovId) => {
    const name = e.target.value;
    var tempFieldOfViews = fieldOfViews;
    if (name !== "") {
      tempFieldOfViews[index] = { fovName: name, fovId: fovId };
    }
    dispatch(getFovNames(tempFieldOfViews));
  };

  const handleCameraNameChange = (e) => {
    const tempCamName = e.target.value;
    const selCamId = !camDetails?.isPairing
      ? camDetails?.camDetails?.id
      : selectedCameraQR;

    isDuplicateCamName(cameraList, selCamId, tempCamName)
      ? setIsDuplCamName(true)
      : setIsDuplCamName(false);
    dispatch(setCameraName(tempCamName));
  };

  const numberOfFOVs = fieldOfViews?.length;

  return (
    <NameStreamGrayContainer>
      <StreamDescriptiveText>
        This camera has {numberOfFOVs} streams. Please assign a descriptive name
        to each stream.
      </StreamDescriptiveText>

      <AutoHeightContainer>
        <Input
          label="Camera name"
          width="328px"
          required={true}
          error={isDuplCamName}
          errorText="Duplicate Camera Name Found"
          onChange={handleCameraNameChange}
          data-testid={CAMERA_ONBOARDING_TEST_IDS.CAMERA_NAME_INPUT}
          value={cameraName}
        />
      </AutoHeightContainer>

      {fieldOfViews.length > 0 &&
        fieldOfViews.map((i, index) => {
          return (
            <FrameForAllFOVs>
              <FrameForIMGandInput>
                <FrameForImages>
                  <SnapshotComponent
                    editFlow={editFlow}
                    fovObj={i}
                    selectedCameraQR={selectedCameraQR}
                    companionSelected={companionSelected}
                  />
                </FrameForImages>
                <FrameForLabelAndInput>
                  <Input
                    type="text"
                    required={true}
                    label={`Stream ${index + 1}`}
                    defaultValue={i.fovName}
                    onChange={(e) => {
                      handleFOVNameChange(e, index, i.fovId);
                    }}
                    data-testid={CAMERA_ONBOARDING_TEST_IDS.STREAM_NAME_INPUT}
                  />
                </FrameForLabelAndInput>
              </FrameForIMGandInput>
            </FrameForAllFOVs>
          );
        })}
    </NameStreamGrayContainer>
  );
};

export default NameStream;
